import "./EmptyMessage.css";

import { FC } from "react";

interface EmptyMessageProps {
    message: string;
}

const EmptyMessage: FC<EmptyMessageProps> = ({ message }) => (
    <div className="empty-message">
        <img src="/images/logo-mobile.svg" alt="logo" />
        <h2>{message}</h2>
    </div>
);

export default EmptyMessage;
